var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-[#2C2C2C]"
  }, [_c('div', {
    staticClass: "w-1200px mx-auto pt-55px pb-24px flex justify-center"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "text-26px leading-26px text-[#ffffff] font-500"
  }, [_vm._v(" 个人中心 ")]), _c('div', {
    staticClass: "text-18px text-[#aaaaaa] ml-80px leading-26px children:mb-10px"
  }, [_c('div', {
    staticClass: "flex-btw children:cursor-pointer"
  }, [_c('div', {
    staticClass: "mr-76px hover:text-[#d7000f]",
    class: _vm.activatedLabel('OrderCenter'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('OrderCenter');
      }
    }
  }, [_vm._v(" 订单中心 ")]), _c('div', {
    staticClass: "hover:text-[#d7000f]",
    class: _vm.activatedLabel('VehicleCenter'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('VehicleCenter');
      }
    }
  }, [_vm._v(" 车辆中心 ")])]), false ? _c('div', {
    staticClass: "flex-btw children:cursor-pointer"
  }, [_c('div', {
    staticClass: "mr-76px hover:text-[#d7000f]",
    class: _vm.activatedLabel('IntegralCenter'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('IntegralCenter');
      }
    }
  }, [_vm._v(" 积分中心 ")]), _c('div', {
    staticClass: "hover:text-[#d7000f]",
    class: _vm.activatedLabel('IntegralOrder'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('IntegralOrder');
      }
    }
  }, [_vm._v(" 积分订单 ")])]) : _vm._e(), _c('div', {
    staticClass: "flex-btw children:cursor-pointer"
  }, [_c('div', {
    staticClass: "mr-76px hover:text-[#d7000f]",
    class: _vm.activatedLabel('InvoiceCenter'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('InvoiceCenter');
      }
    }
  }, [_vm._v(" 发票中心 ")]), _c('div', {
    staticClass: "hover:text-[#d7000f]",
    class: _vm.activatedLabel('AddressManager'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('AddressManager');
      }
    }
  }, [_vm._v(" 收货地址 ")])]), _c('div', {
    staticClass: "flex-btw children:cursor-pointer"
  }, [_c('div', {
    staticClass: "mr-76px hover:text-[#d7000f]",
    class: _vm.activatedLabel('IntegralOrder'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('IntegralOrder');
      }
    }
  }, [_vm._v(" 积分订单 ")]), _c('div', {
    staticClass: "hover:text-[#d7000f]",
    class: _vm.activatedLabel('AddressManager'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('AddressManager');
      }
    }
  }, [_vm._v(" 收货地址 ")])]), _c('div', {
    staticClass: "flex-btw children:cursor-pointer"
  }, [_c('div', {
    staticClass: "mr-76px hover:text-[#d7000f]",
    class: _vm.activatedLabel('HelpCenter'),
    on: {
      "click": function ($event) {
        return _vm.handleRouterTo('HelpCenter');
      }
    }
  }, [_vm._v(" 疑难解答 ")])])])]), _c('div', {
    staticClass: "w-1px h-126px bg-[#777777] ml-166px mr-110px"
  }), _vm._m(0)]), _vm._m(1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "text-18px text-[#aaa] leading-26px mr-40px"
  }, [_c('div', {
    staticClass: "text-26px leading-26px text-[#ffffff] font-500 mr-80px"
  }, [_vm._v(" 联系我们 ")]), _c('p', {
    staticClass: "pt-8px"
  }, [_vm._v("租赁热线：40000-33160")]), _c('p', {
    staticClass: "pt-3px"
  }, [_vm._v("地址：湖北省老河口市光化大道339号")]), _c('p', {
    staticClass: "pt-3px"
  }, [_vm._v("售后服务：400-0550-205")]), _c('p', {
    staticClass: "pt-3px"
  }, [_vm._v("邮箱：51hdc@ep-ep.com")])]), _c('div', {
    staticClass: "text-16px text-[#AAAAAA] leading-26px flex flex-col items-center"
  }, [_c('img', {
    staticClass: "w-122px h-122px",
    attrs: {
      "src": require("@/assets/images/common/vx.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "mt-8px text-center"
  }, [_vm._v("微信扫码添加客服微信")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "py-18px bg-[#202020] flex-c"
  }, [_c('img', {
    staticClass: "w-20px",
    attrs: {
      "src": require("@/assets/images/icon/icp.svg"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "text-16px text-[#AAAAAA] ml-6px"
  }, [_c('a', {
    staticClass: "cursor-pointer",
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("鄂ICP备2024055494号-1")]), _vm._v(" ｜ "), _c('a', {
    staticClass: "cursor-pointer",
    attrs: {
      "href": "https://beian.mps.gov.cn/#/query/webSearch",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("鄂公网安备 42068202000089号")]), _vm._v(" | "), _c('span', [_vm._v("Copyright © 2024 - 2025 中力租赁（湖北）有限公司 版权所有")])])]);
}];
export { render, staticRenderFns };